import { captureException } from "extensions/sentry";
import Radio from "backbone.radio";

import { SmartTable } from "common/components/table/smartTable";

function isClickedIcon(event, className) {
    try {
        const closestIcon = event.target.closest(".icon");
        return event.target.classList.contains(className) || (closestIcon && closestIcon.classList.contains(className));
    } catch (error) {
        captureException(error);
        return false;
    }
}

export const UsersTable = SmartTable.extend({
    onClickCell(rowView, attribute, model, cell, event) {
        if (attribute === "toggleUserActivation") {
            return this.triggerMethod("toggleUserActivation", rowView);
        }
        
        if (attribute === "mimicUser" && model.isActive()) {
            return this.triggerMethod("mimicUser", rowView);
        }
        
        if (attribute === "merchant_ref") {
            // Open a new tab
            Radio.channel("users").trigger("open:new:tab", {
                merchant_ref: model.get("merchant_ref"),
                display_name: cell.text()
            });
        } else if (attribute === "first_name") {
            this.triggerMethod("editUser", rowView);
        } else if (isClickedIcon(event, "unlock-user")) {
            return this.triggerMethod("unlockUser", rowView.model);
        } else if (isClickedIcon(event, "reset-pass")) {
            return this.triggerMethod("resetPassword", rowView);
        } else if (isClickedIcon(event, "send-activation")) {
            return this.triggerMethod("sendActivation", rowView);
        }
    }
});
